// extracted by mini-css-extract-plugin
module.exports = {"base":"_1IFByb8e0WB31pPiZrjnlS","isHighlighted":"_1E1Jf-FezVnnIp41YKCmfg","content":"CH-Zb-PAMiulFsj3nY3Mf"};